import "./App.css";
import { Route, Routes } from "react-router-dom";
import { ModalProvider } from "components/contexts/ModalContext";
import { MenuProvider } from "header/MenuContext";
import { UserProvider } from "user/UserContext";
import { PostProvider } from "post/PostContext";
import { AuthInitializer } from "auth/AuthInitializer";
import { ProtectedRoute } from "auth/ProtectedRoute";
import { Header } from "header/Header";
import { MainPage } from "pages/MainPage";
import { NoticePage } from "pages/NoticePage";
import { PostListPage } from "post/pages/PostListPage";
import { PostPage } from "post/pages/PostPage";
import { WritePage } from "post/pages/WritePage";
import { MapPage } from "pages/MapPage";
import { MyPage } from "user/MyPage";
import { LaunchingPage } from "pages/LaunchingPage";
import { SponsorPage }  from "sponsor/pages/SponsorPage";
import { SponsorDetailPage } from "sponsor/pages/SponsorDetailPage";
import { RegisterPage } from "auth/register/RegisterPage";
import { LoginModal } from "auth/Login";
import { FindAccountPage } from "auth/find-account/FindAccountPage";
import { ResetPasswordPage } from "auth/reset-password/ResetPasswordPage";
import { InvitePage } from "pages/InvitePage";
import { Toaster } from 'sonner';
import log from "loglevel";

log.setLevel("debug");
// log.setLevel('trace');
// log.setLevel('info');

function App() {
  return (
    <div className="App">
      <Toaster />
      <UserProvider>
        <AuthInitializer />
        <PostProvider>
          <MenuProvider>
            <ModalProvider>
              <Header />
              <Routes>
                <Route path="/" element={<MainPage />} />
                <Route path="/notice" element={<NoticePage />} />
                <Route path="/map" element={<MapPage />} />
                <Route path="/sponsor" element={<SponsorPage />} />
                <Route path="/sponsor/:company" element={<SponsorDetailPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/launching" element={<LaunchingPage />} />
                <Route path="/find-account" element={<FindAccountPage />} />
                <Route path="/reset-password" element={<ResetPasswordPage />} />
                <Route path="/invite" element={<InvitePage />} />
                <Route element={<ProtectedRoute />}>
                  <Route path="/mypage" element={<MyPage />} />
                  <Route path="/postlist" element={<PostListPage />} />
                  <Route path="/posts/:postId" element={<PostPage />} />
                  <Route path="/write" element={<WritePage />} />
                </Route>
              </Routes>
              <LoginModal />
            </ModalProvider>
          </MenuProvider>
        </PostProvider>
      </UserProvider>
    </div>
  );
}

export default App;
